import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a17524c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 땡기는 메뉴를 추가해주세요! 🥩 ", -1))
const _hoisted_2 = { class: "slot-body" }
const _hoisted_3 = ["onDrop"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "메뉴 이미지를 업로드해주세요!", -1))
const _hoisted_5 = { class: "uploaded-file" }

import Modal from "@/components/Modal.vue";
import useModal from "@/hooks/useModal";
import { reactive } from "@vue/reactivity";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const { isModalOpen, openModal, closeModal } = useModal();

const state = reactive({
  menuName: "",
  file: {
    lastModified: -1,
    name: "",
    webkitRelativePath: "",
  } as File,
});

const createMenu = () => {
  if (!state.menuName) {
    alert("메뉴 이름을 적어주세요!");
    return;
  } else if (!state.file.name) {
    alert("메뉴 이미지를 넣어주세요!");
    return;
  }

  store.dispatch("MenuStore/createMenuAsync", {
    menuName: state.menuName,
    file: state.file,
  });

  closeModal();
  return;
};

const uploadImage = async (event: Event) => {
  const uploadedFiles =
    ((event.target as HTMLInputElement).files as FileList) ||
    (event as DragEvent).dataTransfer?.files;

  if (uploadedFiles.length > 1) {
    alert("하나의 이미지만 업로드해주세요!");
    return;
  }

  state.file = uploadedFiles[0];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      class: "add-menu",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(openModal) && _unref(openModal)(...args)))
    }, "땡기는 메뉴가 없다면?"),
    (_unref(isModalOpen))
      ? (_openBlock(), _createBlock(Modal, { key: 0 }, {
          header: _withCtx(() => [
            _hoisted_1
          ]),
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "input-menu-name",
                id: "menu-name",
                placeholder: "새로 추가하고싶은 메뉴 이름을 써주세요!",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).menuName) = $event))
              }, null, 512), [
                [_vModelText, _unref(state).menuName]
              ]),
              _createElementVNode("label", {
                for: "menu-image",
                class: "label-menu-image",
                onDragenter: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
                onDrop: _withModifiers(uploadImage, ["prevent"])
              }, [
                _hoisted_4,
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(state).file.name), 1),
                _createElementVNode("input", {
                  type: "file",
                  accept: "image/*",
                  class: "input-menu-image",
                  id: "menu-image",
                  onChange: uploadImage
                }, null, 32)
              ], 40, _hoisted_3)
            ])
          ]),
          "footer-yes-button": _withCtx(() => [
            _createElementVNode("button", {
              type: "text",
              onClick: createMenu
            }, "완료!")
          ]),
          "footer-close-button": _withCtx(() => [
            _createElementVNode("button", {
              type: "text",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(closeModal) && _unref(closeModal)(...args)))
            }, "다음에 만들게요")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})